import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "mt-5" }
const _hoisted_4 = {
  id: "empty",
  class: "mt-8"
}
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col gap-5 mt-8"
}
const _hoisted_6 = { class: "bg-white p-3 shadow-md rounded-md" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "my-5" }
const _hoisted_9 = { class: "flex items-center gap-2 mt-5 text-lg" }
const _hoisted_10 = { class: "mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Header = _resolveComponent("Header")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_DragDropCardResult = _resolveComponent("DragDropCardResult")!
  const _component_TrueOrFalseCardResult = _resolveComponent("TrueOrFalseCardResult")!
  const _component_GapCardResult = _resolveComponent("GapCardResult")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Loader, {
      loader: _ctx.pageLoader,
      label: "Carregando...",
      loaderType: "progress",
      loaderSize: "h-96"
    }, null, 8, ["loader"]),
    (!_ctx.pageLoader)
      ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("quiz.result.title")), 1)
          ]),
          _createElementVNode("section", _hoisted_3, [
            _createVNode(_component_Header, {
              data: _ctx.quizResult,
              learningName: _ctx.learningName,
              isAdaptative: _ctx.isAdaptative,
              onOnProceed: _ctx.onProceed
            }, null, 8, ["data", "learningName", "isAdaptative", "onOnProceed"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_EmptyData, {
                data: 
            _ctx.quizResult?.questionAnswers?.length === 0 &&
            _ctx.quizResult?.absQuestionAnswers?.length === 0
          ,
                label: _ctx.$t('quiz.result.empty'),
                msgSize: "w-5/12"
              }, null, 8, ["data", "label"])
            ]),
            (
          _ctx.quizResult?.questionAnswers?.length !== 0 ||
          _ctx.quizResult?.absQuestionAnswers?.length !== 0
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quizResult?.questionAnswers, (answer, indexAnswer) => {
                    return (_openBlock(), _createElementBlock("div", { key: indexAnswer }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("p", _hoisted_7, _toDisplayString(answer.question?.prompt), 1),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("labels.generic", {
                      pt: "Resposta: ",
                      en: "Answer: ",
                    })), 1),
                            _createTextVNode(" " + _toDisplayString(answer.selectedItem?.answerText), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_v_icon, {
                                name: `${
                      answer.question?.correctItem?.id ===
                      answer.selectedItem?.id
                        ? 'hi-solid-check-circle'
                        : 'hi-solid-x-circle'
                    }`,
                                scale: 1.3,
                                class: _normalizeClass(
                      answer.question?.correctItem?.id ===
                      answer.selectedItem?.id
                        ? 'text-green-500'
                        : 'text-red-700'
                    )
                              }, null, 8, ["name", "scale", "class"]),
                              _createElementVNode("p", null, _toDisplayString(answer.question?.correctItem?.id ===
                      answer.selectedItem?.id
                        ? _ctx.$t("quiz.right")
                        : _ctx.$t("quiz.wrong")), 1)
                            ]),
                            _createElementVNode("p", _hoisted_10, _toDisplayString(answer.selectedItem?.answerDescription), 1)
                          ])
                        ])
                      ])
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quizResult?.absQuestionAnswers, (answer, indexAnswer) => {
                    return (_openBlock(), _createElementBlock("div", { key: indexAnswer }, [
                      (answer.question.type === _ctx.type.DRAG_AND_DROP)
                        ? (_openBlock(), _createBlock(_component_DragDropCardResult, {
                            key: 0,
                            answer: answer
                          }, null, 8, ["answer"]))
                        : _createCommentVNode("", true),
                      (answer.question.type === _ctx.type.TRUE_OR_FALSE)
                        ? (_openBlock(), _createBlock(_component_TrueOrFalseCardResult, {
                            key: 1,
                            answer: answer
                          }, null, 8, ["answer"]))
                        : _createCommentVNode("", true),
                      (answer.question.type === _ctx.type.FILL_IN_THE_BLANKS)
                        ? (_openBlock(), _createBlock(_component_GapCardResult, {
                            key: 2,
                            answer: answer
                          }, null, 8, ["answer"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}